import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { http, imageUrl } from "@/lib/api";

export default function GalleryPanel() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    http.get("/images").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  const remove = async (id) => {
    await http.delete(`/images/${id}`);
    setItems((x) => x.filter((i) => i.id !== id));
    setOpen(null);
    toast.success("Photo supprimée");
  };

  if (!items) return <div className="card p-10 text-[var(--text-muted)]">Chargement…</div>;

  return (
    <div>
      <h2 className="font-serif text-3xl mb-6">Galerie Photos <span data-testid="gallery-count" className="text-[var(--text-muted)] text-xl">({items.length})</span></h2>
      {items.length === 0 ? (
        <div data-testid="gallery-empty" className="card p-12 text-center text-[var(--text-secondary)]">Aucune image pour l'instant. Créez-en une dans l'onglet Images.</div>
      ) : (
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {items.map((it, i) => (
            <button key={it.id} data-testid={`photo-gallery-card-${i}`} onClick={() => setOpen(it)} className="block w-full break-inside-avoid rounded-2xl overflow-hidden group relative">
              <img src={imageUrl(it.id)} alt={it.prompt} loading="lazy" className="w-full transition-transform duration-500 group-hover:scale-105" />
              <span className="absolute inset-x-0 bottom-0 p-3 text-left text-sm text-white bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">{it.prompt}</span>
            </button>
          ))}
        </div>
      )}
      <Dialog open={!!open} onOpenChange={() => setOpen(null)}>
        <DialogContent className="max-w-3xl bg-[var(--surface)] border-[var(--border)]">
          <DialogTitle className="font-serif text-xl pr-6">{open?.prompt}</DialogTitle>
          {open && <img src={imageUrl(open.id)} alt={open.prompt} className="w-full rounded-xl max-h-[65vh] object-contain" />}
          <DialogDescription className="text-sm text-[var(--text-muted)]">{open?.style} · {open && new Date(open.created_at).toLocaleString("fr-FR")}</DialogDescription>
          <div className="flex gap-2">
            <a data-testid="gallery-modal-download" href={open && imageUrl(open.id)} download className="btn-ghost flex-1"><Download size={16} /> Télécharger</a>
            <button data-testid="gallery-modal-delete" onClick={() => remove(open.id)} className="btn-primary flex-1"><Trash2 size={16} /> Supprimer</button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
